/***
 *
 *   ARTICLE
 *   Wrapper for text-based articles (privacy / terms). Phase 10 — tokens.
 *
 **********/

import { Content } from 'components/lib';
import Style from './article.tailwind.js';

export function Article(props) {
    window.scrollTo(0, 0);

    return (
        <article className={Style.article}>
            <Content>{props.children}</Content>
        </article>
    );
}
